import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { TotalLockers } from "./charts/LockerStatChart";
import { Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

const LockerStat = ({ isLoading, availableData, holdData, occupiedData, totalLocker, lockerStatusList }: any) => {
    return (
        <Box sx={{ background: "white", padding: "20px", borderRadius: "5px" }}>
            <Box sx={{ display: "flex", gap: "20px", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h6" component="p" sx={{ fontWeight: 600 }}>Locker Stats</Typography>
            </Box>
            <TotalLockersContainer isLoading={isLoading} availableData={availableData} holdData={holdData} occupiedData={occupiedData} totalLocker={totalLocker} lockerStatusList={lockerStatusList} />
        </Box>
    );
}

const TotalLockersContainer = ({ isLoading, availableData, holdData, occupiedData, totalLocker, lockerStatusList }: any) => {

    return (
        <Grid container spacing={2} mt={2}>
            <Grid item xs={6}>
                <TotalLockers available={availableData} hold={holdData} occupied={occupiedData} />
            </Grid>
            <Grid item xs={6}>
                {
                    isLoading ? <Skeleton variant="text" height={70} width={80} /> : <Typography variant="h4" component="p">
                        {occupiedData + holdData}/{totalLocker ?? 0}
                    </Typography>
                }
                <Typography sx={{ color: "#5c5b5a" }}>
                    Total Lockers in use (occupied)
                </Typography>
                {
                    isLoading ? <Skeleton variant="text" height={70} width={80} /> : <Typography mt={2} variant="h5" component="p" sx={{ color: "#5c5b5a" }}>
                        {availableData}/{totalLocker}
                    </Typography>
                }
                <Typography sx={{ color: "#91908e" }}>
                    Total empty lockers (available)
                </Typography>
                {
                    isLoading ? <Skeleton variant="text" height={70} width={80} /> : <Typography mt={2} variant="h5" component="p" sx={{ color: "#5c5b5a" }}>
                        {holdData}/{totalLocker}
                    </Typography>
                }
                <Typography sx={{ color: "#91908e" }}>
                    Total blocked lockers
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <TableContainer sx={{ border: '1px solid #e7e7e7' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 600, textTransform: 'uppercase', fontSize: '12px' }}>S.N</TableCell>
                                <TableCell sx={{ fontWeight: 600, textTransform: 'uppercase', fontSize: '12px' }}>Locker type</TableCell>
                                <TableCell sx={{ fontWeight: 600, textTransform: 'uppercase', fontSize: '12px' }}>Available</TableCell>
                                <TableCell sx={{ fontWeight: 600, textTransform: 'uppercase', fontSize: '12px' }}>Occupied</TableCell>
                                <TableCell sx={{ fontWeight: 600, textTransform: 'uppercase', fontSize: '12px' }}>Blocked</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                lockerStatusList && lockerStatusList.map((locker: any, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell sx={{ color: 'gray' }}>{locker.lockerType}</TableCell>
                                        <TableCell sx={{ color: 'gray' }}>{locker.availableLockerCount}</TableCell>
                                        <TableCell sx={{ color: 'gray' }}>{locker.occupiedLockerCount}</TableCell>
                                        <TableCell sx={{ color: 'gray' }}>{locker.holdLockerCount}</TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    )
}

export default LockerStat;